// Centralized site data: images, calendar events, etc.

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/48trrub7_Innovators-Prep-scaled-e1688779709790-removebg-preview.png";

export const IMG = {
  homeHero:
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/q8mgmgup_african-american-girl-learning-robotic-arms-with-a-2022-11-16-17-11-00-utc.jpg",
  specialEdSection:
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/wrqac2kq_playtime-at-kindergarten.jpg",
  carousel: [
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/35ce4t0s_child-playing-superhero-2021-08-26-15-29-32-utc-e1688522595669.jpg",
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/9fypnjbu_little-musician.jpg",
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/q8mgmgup_african-american-girl-learning-robotic-arms-with-a-2022-11-16-17-11-00-utc.jpg",
  ],
  programCardPreschool:
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/obofiocl_image.png",
  programCardSpecialEd:
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/q8mgmgup_african-american-girl-learning-robotic-arms-with-a-2022-11-16-17-11-00-utc.jpg",
  aboutVision:
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/xuajp3ar_studio-portrait-mixed-race-girl-looking-lying-alone-isolated-against-a-yellow-background-cute-hisp.jpg",
  classroomBlur:
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/m13jb8op_kindergarten-students-sitting-on-the-floor.jpg",
  preschoolCollage: [
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/dtkibah4_multi-cultural-children-playing-with-colorful-blocks-on-table-in-a-primary-interracial-classroom.jpg",
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/8ui1zznr_image-1.png",
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/66fszlof_an-interested-pre-school-child-building-something-2023-01-06-18-07-00-utc-e1688522417962.jpg",
  ],
  preschoolApproach:
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/nkdok7d0_little-girl-playing-with-a-science-kit-at-preschoo-2022-11-07-03-55-01-utc.jpg",
  specialEdPrograms:
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/3w8rgtcc_image-2-1.png",
  goalsImage:
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/gaummxwq_portrait-of-multi-cultural-children-hanging-out-with-friends-in-countryside-together.jpg",
  philosophyCollage: [
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/88h7xj7k_group-of-multi-cultural-children-on-window-seat-together.jpg",
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/wipq3hfw_toddler-playing-kinetic-sand-with-plastic-shapes-2023-06-13-05-49-21-utc.jpg",
    "https://customer-assets.emergentagent.com/job_early-learning-hub-28/artifacts/vca5ucve_group-of-kindergarten-kids-friends-arm-around-sitting-and-smiling-fun.jpg",
  ],
};


export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Our Goals", to: "/goals" },
  { label: "Philosophy", to: "/philosophy" },
  { label: "Contact", to: "/contact" },
];
